import React, { ReactNode } from 'react'
import Reveal, { RevealProps } from 'react-awesome-reveal'
import { keyframes } from '@emotion/react'

interface SlideAndFadeProps extends RevealProps {
  children: ReactNode
  direction?: 'up' | 'down' | 'right' | 'left'
}
const SlideAndFade: React.FC<SlideAndFadeProps> = ({ children, direction = 'down', ...props }) => {
  const customAnimation = keyframes`
    from {
      transform: translate(${direction === 'right' ? '-40%' : direction === 'left' ? '40%' : '0'}, ${direction === 'down' ? '-20%' : direction === 'up' ? '20%' : '0'});
      visibility: visible;
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  `

  return (
    <Reveal
      style={{ animationTimingFunction: 'ease-out' }}
      triggerOnce
      keyframes={customAnimation}
      {...props}
    >
      {children}
    </Reveal>
  )
}

export default SlideAndFade
